/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITeamResponse } from './ITeamResponse';
import {
    ITeamResponseFromJSON,
    ITeamResponseFromJSONTyped,
    ITeamResponseToJSON,
    ITeamResponseToJSONTyped,
} from './ITeamResponse';

/**
 * 
 * @export
 * @interface JoinTeamByLinkResponse
 */
export interface JoinTeamByLinkResponse {
    /**
     * 
     * @type {ITeamResponse}
     * @memberof JoinTeamByLinkResponse
     */
    team: ITeamResponse;
}

/**
 * Check if a given object implements the JoinTeamByLinkResponse interface.
 */
export function instanceOfJoinTeamByLinkResponse(value: object): value is JoinTeamByLinkResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function JoinTeamByLinkResponseFromJSON(json: any): JoinTeamByLinkResponse {
    return JoinTeamByLinkResponseFromJSONTyped(json, false);
}

export function JoinTeamByLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinTeamByLinkResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': ITeamResponseFromJSON(json['team']),
    };
}

export function JoinTeamByLinkResponseToJSON(json: any): JoinTeamByLinkResponse {
    return JoinTeamByLinkResponseToJSONTyped(json, false);
}

export function JoinTeamByLinkResponseToJSONTyped(value?: JoinTeamByLinkResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': ITeamResponseToJSON(value['team']),
    };
}

